import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "16",
  viewBox: "0 0 30 16",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "overflowLeft" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5 13C7.76142 13 10 10.7614 10 8C10 5.23858 7.76142 3 5 3C2.23858 3 0 5.23858 0 8C0 10.7614 2.23858 13 5 13Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill_2",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M22 16C26.4183 16 30 12.4183 30 8C30 3.58172 26.4183 0 22 0C17.5817 0 14 3.58172 14 8C14 12.4183 17.5817 16 22 16Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }